import dayjs from 'dayjs';

import { CourseInstanceStatus } from '../types/CourseInstance';

export const courseInstanceIsAcceptable = (
  instructorId?: number | null,
  startsAt?: string,
  courseInstanceStatus?: CourseInstanceStatus,
) => {
  return (
    instructorId === null &&
    dayjs(startsAt).isAfter(dayjs()) &&
    courseInstanceStatus === CourseInstanceStatus.Ordered
  );
};
